<template>
  <div class="testimonial-center-slider">
    <div class="container">
      <div class="testimonial-center">
        <Slick v-if="render" class="carousel" :options="slickOptions">
          <div ngxSlickItem v-for="(slide,i) of logoList" :key="i" class="slide">
            <div class="col-sm-12 col-md-9 mx-auto">
              <div class="carousel-item active text-center">
                <p class="text-white text-center lead mb-4">„{{slide.fields.description}}“</p>
              </div>
            </div>
          </div>
        </Slick>
      </div>
    </div>
  </div>
</template>

<script>
import client from "../../utils/api.js";
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
export default {
  components: {
    Slick
  },
  data() {
    return {
      logoList: [],
      render: false,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        dots: false,
        fade: true,
        vertical: false,
        variablewidth: true,
        prevArrow:
          "<i class='arrow fa fa-angle-left slick-prev pull-left d-flex' aria-hidden='true'></i>",
        nextArrow:
          "<i class='arrow fa fa-angle-right slick-next pull-right d-flex' aria-hidden='true' ></i>",
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      }
    };
  },
  methods: {},
  mounted() {
    client
      .getEntries({ content_type: "testimonial", order: "-sys.createdAt" })
      .then(response => {
        this.logoList = [];
        this.logoList = Array.from(response.items);
        this.render = true;
      });
  },
  beforeCreate() {},
  created() {}
};
</script>
<style >
.testimonial-center-slider {
  padding-top: 40px;
}

.slick-slider {
  display: flex;
}

.arrow {
  font-size: 30px;
  align-items: center;
  display: inline;
}

@media screen and (max-width: 578px) {
  .slick-slider {
    display: table;
    table-layout: fixed;
    width: 100%;
  }
  .slick-slider > .arrow {
    display: none !important;
  }
}

/*XR*/
@media screen and (width: 828px) and (height: 1792px) {
  .lead {
    font-size: 1.9em !important;
  }
}
</style>

